enum Color {
  TEXT_PRIMARY = 'rgba(0, 0, 0, 0.88);',
  TEXT_SECONDARY = 'rgb(125, 125, 125)',
  TEXT_HIGHLIGHT = '#00b8a9',

  BACKGROUND = '#fbfcf7',

  CODE_BACKGROUND = 'rgba(0, 0, 0, 0.15)',
}

export default Color;
